import { render, staticRenderFns } from "./TitularidadeIngressoTabs.vue?vue&type=template&id=81696d9a&scoped=true"
import script from "./TitularidadeIngressoTabs.vue?vue&type=script&lang=js"
export * from "./TitularidadeIngressoTabs.vue?vue&type=script&lang=js"
import style0 from "./TitularidadeIngressoTabs.vue?vue&type=style&index=0&id=81696d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81696d9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
